export { gcDepartureId, useGcDepartureId } from "./gc-departure-id";
